"use client";
import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import Image from "next/image";
import { IMAGES } from "../constants/images";

const TestimonialsSection = () => {
  const { t } = useTranslation();

  const testimonials = [
    { key: "t1", avatar: IMAGES.HADEESA_AVATAR },
    { key: "t3", avatar: IMAGES.RAMIZ_AVATAR },
    { key: "t4", avatar: IMAGES.MOAZZAM_AVATAR },
  ];

  return (
    <Box
      sx={{
        py: { xs: 5, sm: 7, md: 10 },
        px: { xs: 1.5, sm: 2, md: 4 },
        backgroundImage: `url(https://getgeek-website-assets.b-cdn.net/TestimonialsSectionBG.webp)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container maxWidth="lg">
        <Typography
          sx={{
            fontFamily: "var(--font-plusjakarta)",
            fontWeight: 700,
            fontSize: { xs: "1.4rem", sm: "1.8rem", md: "2.7rem" },
            textAlign: "center",
            color: "#101828",
            lineHeight: { xs: 1.4, sm: 1.35, md: 1.3 },
            mb: { xs: 3, sm: 4, md: 5 },
            px: { xs: 1, sm: 0 },
          }}
        >
          <Box component="span" sx={{ color: "#9810FA" }}>
            {t("testimonials.headingHighlight")}
          </Box>{" "}
          {t("testimonials.heading")}
          <br />
          {t("testimonials.headingLine2")}
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, minmax(0, 1fr))",
            },
            gap: { xs: 1.5, sm: 2, md: 3 },
          }}
        >
          {testimonials.map(({ key, avatar }) => (
            <Box
              key={key}
              sx={{
                border: "1px solid #E5E7EB",
                borderRadius: "16px",
                p: { xs: 2, sm: 2.5, md: 3.5 },
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#fff",
              }}
            >
              {/* Avatar */}
              <Box
                sx={{
                  width: { xs: 38, sm: 44, md: 52 },
                  height: { xs: 38, sm: 44, md: 52 },
                  borderRadius: "50%",
                  overflow: "hidden",
                  flexShrink: 0,
                  border: "2px solid #f3f4f6",
                  mb: { xs: 1.5, sm: 2 },
                }}
              >
                <Image
                  src={avatar}
                  alt={t(`QualifiedCandidatestestimonials.${key}.name`)}
                  width={52}
                  height={52}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </Box>

              {/* Quote — minHeight fix ✅ */}
              <Box
                sx={{
                  flexGrow: 1,
                  minHeight: { md: "130px" }, // ✅ sabse lambi quote ke barabar
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "var(--font-outfit)",
                    fontSize: { xs: "0.78rem", sm: "0.82rem", md: "0.92rem" },
                    color: "#374151",
                    lineHeight: { xs: 1.7, sm: 1.72, md: 1.75 },
                  }}
                >
                  "{t(`QualifiedCandidatestestimonials.${key}.text`)}"
                </Typography>
              </Box>

              {/* Divider */}
              <Box
                sx={{
                  height: "1px",
                  backgroundColor: "#F3F4F6",
                  mt: { xs: 1.5, sm: 2 },
                  mb: { xs: 1.5, sm: 2 },
                  flexShrink: 0,
                }}
              />

              {/* Name + Role */}
              <Box sx={{ flexShrink: 0 }}>
                <Typography
                  sx={{
                    fontFamily: "var(--font-outfit)",
                    fontWeight: 600,
                    fontSize: { xs: "0.75rem", sm: "0.78rem", md: "0.85rem" },
                    color: "#1a1a2e",
                    mb: 0.3,
                  }}
                >
                  {t(`QualifiedCandidatestestimonials.${key}.name`)}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "var(--font-outfit)",
                    fontSize: { xs: "0.68rem", sm: "0.7rem", md: "0.78rem" },
                    color: "#374151",
                  }}
                >
                  {t(`QualifiedCandidatestestimonials.${key}.role`)}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default TestimonialsSection;